import React, { useState, useEffect } from 'react';
import { Cycle } from '@/api/entities';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { useTranslation } from 'react-i18next';

const initialFormState = {
  name: '',
  description: '',
};

export default function CycleForm({ isOpen, onClose, onSave, cycle = null }) {
    const { t } = useTranslation();
    const [formData, setFormData] = useState(initialFormState);
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        if (isOpen) {
            if (cycle) {
                setFormData({
                    name: cycle.name || '',
                    description: cycle.description || '',
                });
            } else {
                setFormData(initialFormState);
            }
        }
    }, [isOpen, cycle]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        try {
            if (cycle) {
                await Cycle.update(cycle.id, formData);
            } else {
                await Cycle.create(formData);
            }
            onSave();
        } catch (error) {
            console.error('Error saving cycle:', error);
        }
        
        setIsSubmitting(false);
    };

    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent className="max-w-md bg-white">
                <DialogHeader>
                    <DialogTitle className="text-xl font-bold text-slate-900">
                        {cycle ? t('cycle.edit_title') : t('cycle.title')}
                    </DialogTitle>
                </DialogHeader>

                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <Label htmlFor="name">{t('cycle.name')} *</Label>
                        <Input
                            id="name"
                            value={formData.name}
                            onChange={(e) => setFormData(prev => ({ ...prev, name: e.target.value }))}
                            required
                            className="bg-white"
                        />
                    </div>

                    <div>
                        <Label htmlFor="description">{t('cycle.description')}</Label>
                        <Textarea
                            id="description"
                            value={formData.description}
                            onChange={(e) => setFormData(prev => ({ ...prev, description: e.target.value }))}
                            className="h-24 bg-white"
                        />
                    </div>

                    <div className="flex justify-between items-center pt-4">
                        <Button type="button" variant="outline" onClick={onClose} className="bg-white">
                            {t('actions.cancel')}
                        </Button>
                        <Button 
                            type="submit" 
                            disabled={isSubmitting || !formData.name}
                            className="bg-amber-600 hover:bg-amber-700 text-white"
                        >
                            {isSubmitting ? t('cycle.saving') : t('cycle.save')}
                        </Button>
                    </div>
                </form>
            </DialogContent>
        </Dialog>
    );
}